<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="6"
    viewBox="0 0 21 6"
    fill="none"
  >
    <path
      d="M19.9662 3.50518C20.142 3.39945 20.2498 3.20748 20.2498 3.00032C20.2498 2.79315 20.142 2.60118 19.9663 2.49545L16.784 0.582C16.6051 0.474551 16.3832 0.472543 16.2026 0.577129C16.0221 0.681426 15.9105 0.875979 15.9105 1.08687L15.9105 1.93958L0.828665 1.93958C0.509201 1.93958 0.250183 2.20233 0.250183 2.5264L0.250183 3.47424C0.250183 3.7983 0.509201 4.06105 0.828665 4.06105L15.9105 4.06105L15.9105 4.9132C15.9105 5.12408 16.0219 5.31864 16.2026 5.42293C16.3832 5.52752 16.6051 5.52551 16.7839 5.41806L19.9662 3.50518Z"
    />
  </svg>
</template>
